/**
 * @generated SignedSource<<3a3b704d6ce65f5b13cc233cd7661373>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobFooter_Job$data = {
  readonly firm: {
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly incognito: boolean | null | undefined;
  readonly jobApplication: {
    readonly " $fragmentSpreads": FragmentRefs<"JobFooter_JobApplication">;
  } | null | undefined;
  readonly " $fragmentType": "JobFooter_Job";
};
export type JobFooter_Job$key = {
  readonly " $data"?: JobFooter_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobFooter_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobFooter_Job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incognito",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobApplication",
      "kind": "LinkedField",
      "name": "jobApplication",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobFooter_JobApplication"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "a18e02a31b3d18dcc785f319762fcb6a";

export default node;
